import APIClient from "../APIClientV2/APIClient"

export default class Router {

    async newVersion() {

        if (this.config.origin.isDevEnv) {
            return false
        }

        let verData

        try {

            const response = await fetch(
                window.location.origin
                + "/version.json?preview=true"
            )

            verData = await response.json()
            return (verData.version !== Version)

        } catch (error) {
            return false
        }
    }

    updateModule(pClass, pParams, pApiResult) {

        if (this.currentModule?.constructor.name === pClass) {
            return this.currentModule.update(
                pParams
            )
        }

        if (this.currentModule) {
            this.currentModule.removeMeta()
            this.currentModule.removeLinkCanonical()
        }
    }

    newModule(pModSrc, pParams) {

        const modClass = new pModSrc.default({
            params: pParams
        })

        this.currentModule = modClass
        return this.currentModule
    }

    async route(pURL, pParams) {

        this.getPageFunction = this.staticRoutes[pURL]

        if (typeof this.getPageFunction !== "undefined") {
            return this.getPageFunction(pParams)
        }

        if (!this.config.routerEndPoint) {

            const error = new Error(
                "Error 404"
            )
            error.code = 404
            error.type = "route"
            error.url = pURL

            this.getPageFunction = this.staticRoutes["404"]
            pParams.error = error
            return this.getPageFunction(pParams)
        }

        const module = await this.routeAPI(pURL, pParams)
        return module
    }

    getAPIResult(pViewResult, pParams) {

        const url = pViewResult?.Results?.URL?.Payload

        if (!url) {
            return {
                module: "URL"
            }
        }

        const params = {
            module: url.Module
        }

        if (
            (typeof pParams === "object")
            && (pParams !== null)
        ) {
            Object.assign(params, pParams)
        }

        Object.entries(pViewResult.Results).forEach(([resultId, result]) => {
            if (result.Payload) {
                params[resultId] = result.Payload
            }

        })

        return params
    }

    async routeAPI(pURL, pParams) {

        const apiClient = new APIClient(
            this.config.origin.apiClient
        )

        return apiClient.fetch({
            endPoint: (
                this.config.routerEndPoint
                + ""
                + pURL
            )
        }).then(viewResult => {

            const apiResult = this.getAPIResult(
                viewResult,
                pParams
            )

            if (apiResult) {

                this.getPageModule = this.apiModules[apiResult.module]

                if (typeof this.getPageModule !== "undefined") {
                    return this.getPageModule(apiResult)
                }
            }

            const error = new Error(
                "Missing Module " + apiResult.module
            )
            error.code = 999
            error.type = "module"
            error.module = apiResult.module

            throw error

        }).catch(error => {

            if (
                (error.type === "fetch")
                && (error.code === 401)
            ) {

                return this.link(
                    "/login" + window.location.search,
                    {
                        nextURL: pURL,
                        error: error
                    }
                )
            }

            if (
                (error.type === "fetch")
                && (error.code === 404)
            ) {

                this.getPageFunction = this.staticRoutes["404"]
                error.url = pURL

                return this.getPageFunction({
                    searchParams: pParams,
                    error: error
                })
            }

            throw error

        })
    }

    async link(pURL, pParams) {

        if (await this.newVersion()) {

            window.location.assign(pURL)
            return
        }

        if (pURL.toLowerCase() != window.location.pathname.toLowerCase()) {

            window.history.pushState(
                this.state, null, pURL
            )

            this.go(pURL, pParams)
            return
        }

    }

    async go(pURL, pParams) {

        const params = {}

        const url = new URL(
            pURL,
            window.location.origin
        )

        if (url.searchParams.size > 0) {

            params.searchParams = {}

            url.searchParams.forEach((value, key) => {
                params.searchParams[key] = value
            })
        }

        if (
            (typeof pParams === "object")
            && (pParams !== null)
        ) {
            Object.assign(params, pParams)
        }

        this.route(
            url.pathname,
            params
        ).then((pModule) => {

            if (pModule) {
                this.onOpen(pModule)
            }
        })
    }

    constructor(p) {

        this.onOpen = p.onOpen
        this.config = p.config
        this.state = {}

        window.addEventListener("popstate", (pEvt) => {
            this.go(window.location.href)
        })

        window.addEventListener("anchorEvent", (pEvt) => {
            if (pEvt.detail.type === "link") {

                this.link(
                    pEvt.detail.href,
                    pEvt.detail.params
                )

                return
            }

            this.go(
                pEvt.detail.href,
                pEvt.detail.params
            )

        })

        this.staticRoutes = {}
        this.apiModules = {}
    }
}